import React from "react";
import styles from "./SectionTemplate.module.css";

const SectionTemplate = ({ children, bgColor = "transparent" }) => {
  return (
    <section className={styles.section} style={{ backgroundColor: bgColor }}>
      <div className={styles.container}>{children}</div>
    </section>
  );
};

export default SectionTemplate;
